import { render, staticRenderFns } from "./ConversationPermissionsSettings.vue?vue&type=template&id=4f0f91e2&scoped=true"
import script from "./ConversationPermissionsSettings.vue?vue&type=script&lang=js"
export * from "./ConversationPermissionsSettings.vue?vue&type=script&lang=js"
import style0 from "./ConversationPermissionsSettings.vue?vue&type=style&index=0&id=4f0f91e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f91e2",
  null
  
)

export default component.exports